export default __webpack_public_path__ + "static/accessories-98e3d3896489fefc9cd741850ba8881c.webp";